import React, { useState, useEffect } from 'react';
import {
    Grid, TextField, FormControl, InputLabel, Select, MenuItem,
    Checkbox, FormControlLabel, Button, Typography, Box
} from '@mui/material';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';
import imageCompression from 'browser-image-compression';

function AddSucursal({ handleNewSucursal, editSucursal }) {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const { user } = useUser();

    const [codigo, setCodigo] = useState('');
    const [nombre, setNombre] = useState('');
    const [direccion, setDireccion] = useState('');
    const [telefono, setTelefono] = useState('');
    const [celular, setCelular] = useState('');
    const [horarioAtencion, setHorarioAtencion] = useState('');
    const [abreviatura, setAbreviatura] = useState('');
    const [empresa, setEmpresa] = useState('');
    const [banco, setBanco] = useState('');
    const [cuentaBancaria, setCuentaBancaria] = useState('');
    const [empresas, setEmpresas] = useState([]);
    const [bancos, setBancos] = useState([]);
    const [cuentasBancarias, setCuentasBancarias] = useState([]);
    const [urlGoogleMap, setUrlGoogleMap] = useState('');
    const [nombreComercial, setNombreComercial] = useState('');
    const [urlImagen, setUrlImagen] = useState('');
    const [mostrarEnPaginaWeb, setMostrarEnPaginaWeb] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    
    const [IngresadoPor, setIngresadoPor] = useState('');

    const [descripcionPagWeb, setDescripcionPagWeb] = useState('');
    const [palabrasClavePagWeb, setPalabrasClavePagWeb] = useState('');

    const [urlImagenMapa, setUrlImagenMapa] = useState('');
    const [imagePreviewMapa, setImagePreviewMapa] = useState(null);
    const [orden, setOrden] = useState(0);
    const [principal, setPrincipal] = useState(false);

    useEffect(() => {
        async function fetchData() {
            const resEmpresas = await fetch(`${server}/MgEmpresas`);
            const empresasData = await resEmpresas.json();
            setEmpresas(empresasData.$values);

            const resBancos = await fetch(`${server}/ChkBancoes`);
            const bancosData = await resBancos.json();
            setBancos(bancosData.$values);

            if (editSucursal) {
                setCodigo(editSucursal.codigo);
                setNombre(editSucursal.nombreSucursal);
                setDireccion(editSucursal.direccionCompleta);
                setTelefono(editSucursal.telefono);
                setCelular(editSucursal.celular);
                setHorarioAtencion(editSucursal.horario);
                setAbreviatura(editSucursal.abreviatura);
                setEmpresa(editSucursal.idEmpresa);
                setBanco(editSucursal.idBanco);
                setCuentaBancaria(editSucursal.idCuentaBancaria);
                setUrlGoogleMap(editSucursal.urlGoogleMap || '');
                setNombreComercial(editSucursal.nombreComercial || '');
                setUrlImagen(editSucursal.urlImagen || '');
                setMostrarEnPaginaWeb(editSucursal.mostrarEnPaginaWeb || false);
                setIngresadoPor(editSucursal.ingresadoPor);

                setDescripcionPagWeb(editSucursal.descripcionPagWeb);
                setPalabrasClavePagWeb(editSucursal.palabrasClavePagWeb);

                setUrlImagenMapa(editSucursal.urlImagenMapa || '');
                setOrden(editSucursal.orden || 0);
                setPrincipal(editSucursal.principal === 1 || editSucursal.principal === true);
            }
        }
        fetchData();
    }, [editSucursal]);

    useEffect(() => {
        async function fetchCuentasBancarias() {
            if (banco) {
                const response = await fetch(`${server}/ChkBancosCuentasBancarias/${banco}`);
                const cuentasData = await response.json();
                setCuentasBancarias(cuentasData.$values);
            } else {
                setCuentasBancarias([]);
            }
        }
        fetchCuentasBancarias();
    }, [banco]);

    
    // Función para comprimir la imagen
    const comprimirImagen = async (imagen) => {
    const opciones = {
    maxSizeMB: 0.5,           // Tamaño máximo en MB (ej: 0.5 MB = 500 KB)
    maxWidthOrHeight: 1280,   // Redimensiona si es más grande
    useWebWorker: true,
    initialQuality: 0.8
    };

    try {
        const imagenComprimida = await imageCompression(imagen, opciones);
    
    //extensión original
    const extension = imagen.name.split('.').pop();
    const nuevoNombre = `${imagen.name.split('.')[0]}.${extension}`;

    //Crear un nuevo objeto File con nombre y extension correcta
    const archivoFinal = new File (
      [imagenComprimida],
      nuevoNombre,
      {
        type: imagen.type,
        lastModified: Date.now()
      }
    );
        return archivoFinal;
    } catch (error) {
        console.error('Error al comprimir imagen:', error);
        return imagen; // Si falla, usa la imagen original
    }
    };


    // const handleImageUpload = async (file) => {
    //     const archivoComprimido = await comprimirImagen(file);

    //     const formData = new FormData();
    //     // formData.append('file', file);
    //     formData.append('file', archivoComprimido);
    //     const username = user?.codigoUsuario || 'ADMIN';

    //     try {
    //         // const response = await fetch(`${server}/MgSucursales/upload?usuario=${username}&sucursalId=${editSucursal.idSucursal}`, {
    //         const response = await fetch(`${server}/MgSucursales/upload?usuario=${username}&sucursalId=${editSucursal.idSucursal}&camposDestino=UrlImagen`, {
    //             method: 'POST',
    //             body: formData
    //         });

    //         if (response.ok) {
    //             const data = await response.json();
    //             setUrlImagen(data.urlImagen);
    //             // setImagePreview(URL.createObjectURL(file));
    //             setImagePreview(URL.createObjectURL(archivoComprimido));
    //         } else {
    //             alert('Error al subir la imagen');
    //         }
    //     } catch (error) {
    //         console.error('Error:', error);
    //         alert('Error al subir la imagen');
    //     }
    // };

        const handleImageUpload = async (file, campoDestino, setUrl, setPreview) => {
        const archivoComprimido = await comprimirImagen(file);

        const formData = new FormData();
        formData.append('file', archivoComprimido);

        const username = user?.codigoUsuario || 'ADMIN';

        try {
            const response = await fetch(
                `${server}/MgSucursales/upload?usuario=${username}&sucursalId=${editSucursal.idSucursal}&campoDestino=${campoDestino}`,
                {
                    method: 'POST',
                    body: formData
                }
            );

            if (response.ok) {
                const data = await response.json();
                setUrl(data.url);
                setPreview(URL.createObjectURL(archivoComprimido));
            } else {
                alert('Error al subir la imagen');
            }
        } catch (error) {
            console.error(error);
            alert('Error al subir la imagen');
        }
    };



    // const handleImageUploadMapa = async (file) => {
    //     const archivoComprimido = await comprimirImagen(file);

    //     const formData = new FormData();
    //     // formData.append('file', file);
    //     formData.append('file', archivoComprimido);
    //     const username = user?.codigoUsuario || 'ADMIN';

    //     try {
    //         const response = await fetch(`${server}/MgSucursales/upload?usuario=${username}&sucursalId=${editSucursal.idSucursal}&camposDestino=UrlImagenMapa`, {
    //             method: 'POST',
    //             body: formData
    //         });

    //         if (response.ok) {
    //             const data = await response.json();
    //             setUrlImagenMapa(data.urlImagenMapa);
    //             // setImagePreview(URL.createObjectURL(file));
    //             setImagePreviewMapa(URL.createObjectURL(archivoComprimido));
    //         } else {
    //             alert('Error al subir la imagen');
    //         }
    //     } catch (error) {
    //         console.error('Error:', error);
    //         alert('Error al subir la imagen');
    //     }
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (editSucursal) {
            // Modo edición: enviar todas las propiedades
            const sucursalUpdate = {
                idSucursal: editSucursal.idSucursal,
                codigo: codigo,
                nombreSucursal: nombre,
                direccionCompleta: direccion,
                telefono: telefono,
                celular: celular,
                horario: horarioAtencion,
                abreviatura: abreviatura,
                idCuentaBancaria: cuentaBancaria,
                idEmpresa: empresa,
                fechaIngreso: editSucursal.fechaIngreso,
                ingresadoPor: editSucursal.ingresadoPor,
                modificacion: editSucursal.modificacion,
                modificadoPor: user?.codigoUsuario || 'ADMIN',
                fechaModificacion: new Date().toISOString(),
                urlGoogleMap: urlGoogleMap,
                nombreComercial: nombreComercial,
                urlImagen: urlImagen,
                mostrarEnPaginaWeb: mostrarEnPaginaWeb,
                descripcionPagWeb: descripcionPagWeb,
                palabrasClavePagWeb: palabrasClavePagWeb,
                urlImagenMapa: urlImagenMapa,
                orden: orden,
                principal: principal ? 1 : 0
            };
            
            const response = await fetch(`${server}/MgSucursales/${editSucursal.idSucursal}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(sucursalUpdate)
            });

            if (response.ok) {
                alert('Sucursal actualizada exitosamente!');
                handleNewSucursal();
            } else {
                const errorData = await response.json().catch(() => ({}));
                alert('Error al actualizar la sucursal: ' + (errorData.message || ''));
            }
        } else {
            // Modo creación: enviar todos los campos
            const sucursal = {
                idSucursal: 0,
                codigo,
                nombreSucursal: nombre,
                direccionCompleta: direccion,
                telefono,
                celular,
                horario: horarioAtencion,
                abreviatura,
                idCuentaBancaria: cuentaBancaria,
                idEmpresa: empresa,
                fechaIngreso: new Date().toISOString(),
                ingresadoPor: user?.codigoUsuario || 'ADMIN',
                urlGoogleMap: urlGoogleMap,
                nombreComercial: nombreComercial,
                urlImagen: urlImagen,
                mostrarEnPaginaWeb: mostrarEnPaginaWeb,
                descripcionPagWeb,
                palabrasClavePagWeb,
                urlImagenMapa: urlImagenMapa,
                orden: orden,
                principal: principal ? 1 : 0
            };

            const response = await fetch(`${server}/MgSucursales`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(sucursal)
            });

            if (response.ok) {
                alert('Sucursal creada exitosamente!');
                handleNewSucursal();
            } else {
                const errorData = await response.json();
                alert('Error al crear la sucursal: ' + (errorData.message || ''));
            }
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                    <TextField label="Código" value={codigo} onChange={(e) => setCodigo(e.target.value)} fullWidth required />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField label="Nombre" value={nombre} onChange={(e) => setNombre(e.target.value)} fullWidth required />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField label="Dirección Completa" value={direccion} onChange={(e) => setDireccion(e.target.value)} fullWidth required />
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField label="Teléfono" value={telefono} onChange={(e) => setTelefono(e.target.value)} fullWidth required />
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField label="Celular" value={celular} onChange={(e) => setCelular(e.target.value)} fullWidth required />
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField label="Horario Atención" value={horarioAtencion} onChange={(e) => setHorarioAtencion(e.target.value)} fullWidth required />
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField label="Abreviatura" value={abreviatura} onChange={(e) => setAbreviatura(e.target.value)} fullWidth required />
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                        <InputLabel>Empresa</InputLabel>
                        <Select value={empresa} onChange={(e) => setEmpresa(e.target.value)}>
                            {empresas.map((emp) => (
                                <MenuItem key={emp.idEmpresa} value={emp.idEmpresa}>{emp.nombreCompleto}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                        <InputLabel>Banco</InputLabel>
                        <Select value={banco} onChange={(e) => setBanco(e.target.value)}>
                            {bancos.map((b) => (
                                <MenuItem key={b.idBanco} value={b.idBanco}>{b.nombreBanco}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                        <InputLabel>Cuenta Bancaria</InputLabel>
                        <Select value={cuentaBancaria} onChange={(e) => setCuentaBancaria(e.target.value)}>
                            {cuentasBancarias.map((c) => (
                                <MenuItem key={c.idCuentaBancaria} value={c.idCuentaBancaria}>{c.cuentaBancaria}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField label="Nombre Comercial" value={nombreComercial} onChange={(e) => setNombreComercial(e.target.value)} fullWidth />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField label="URL Google Maps" value={urlGoogleMap} onChange={(e) => setUrlGoogleMap(e.target.value)} fullWidth />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Button variant="outlined" component="label" fullWidth>
                        Subir Imagen
                        {/* <input type="file" hidden onChange={(e) => handleImageUpload(e.target.files[0])} /> */}
                        <input type="file" hidden onChange={(e) => handleImageUpload(e.target.files[0], 'UrlImagen', setUrlImagen, setImagePreview)}/>
                    </Button>
                    {imagePreview || urlImagen ? (
                        <Box mt={2}>
                            <img src={imagePreview || urlImagen} alt="Preview" style={{ maxHeight: 150 }} />
                        </Box>
                    ) : null}
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormControlLabel
                        control={<Checkbox checked={mostrarEnPaginaWeb} onChange={(e) => setMostrarEnPaginaWeb(e.target.checked)} />}
                        label="Mostrar en Página Web"
                    />
                </Grid>

                 <Grid item xs={12} md={6}>
                    <TextField label="Descripción Página Web" value={descripcionPagWeb} onChange={(e) => setDescripcionPagWeb(e.target.value)} fullWidth required />
                </Grid>
                 <Grid item xs={12} md={6}>
                    <TextField label="Palabras clave" value={palabrasClavePagWeb} onChange={(e) => setPalabrasClavePagWeb(e.target.value)} fullWidth required />
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField label="Orden" type="number" value={orden} onChange={(e) => setOrden(parseInt(e.target.value))} fullWidth />
                </Grid>
                <Grid item xs={12} md={3}>
                    <FormControlLabel
                        control={<Checkbox checked={principal} onChange={(e) => setPrincipal(e.target.checked)} />}
                        label="Sucursal Principal"
                    />
                </Grid>
                {/* <Grid item xs={12} md={6}>
                    <Button variant="outlined" component="label" fullWidth>
                        Subir Imagen de Mapa
                        <input type="file" hidden onChange={(e) => handleImageUploadMapa(e.target.files[0])} />
                    </Button>
                    {imagePreviewMapa || urlImagenMapa ? (
                        <Box mt={2}>
                            <img src={imagePreviewMapa || urlImagenMapa} alt="Preview" style={{ maxHeight: 150 }} />
                        </Box>
                    ) : null}
                </Grid> */}
                <Grid item xs={12} md={6}>
                    <Button variant="outlined" component="label" fullWidth>
                        Subir Imagen
                        {/* <input type="file" hidden onChange={(e) => handleImageUpload(e.target.files[0])} /> */}
                        <input type="file" hidden onChange={(e) => handleImageUpload(e.target.files[0], 'UrlImagenMapa', setUrlImagenMapa, setImagePreviewMapa)}/>
                    </Button>
                    {imagePreviewMapa || urlImagenMapa ? (
                        <Box mt={2}>
                            <img src={imagePreviewMapa || urlImagenMapa} alt="Preview" style={{ maxHeight: 150 }} />
                        </Box>
                    ) : null}
                </Grid>

                <Grid item xs={12}>
                    <Box display="flex" justifyContent="flex-end" gap={2}>
                        <Button variant="outlined" color="secondary" onClick={() => window.history.back()}>Cancelar</Button>
                        <Button type="submit" variant="contained" color="primary" disabled={!tienePermiso('Crear Sucursal')}>Guardar</Button>
                    </Box>
                </Grid>
            </Grid>
        </form>
    );
}

export default AddSucursal;
